import { useState } from 'react'
import { Link, useRouterState, useNavigate } from '@tanstack/react-router'
import { LogOut } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'
import logoImg from '../assets/side-logo.svg'
import { ConfirmationModal } from '@/components/ConfirmationModal'

const navItems = [
    { to: '/', label: 'Chatbot Management' },
    { to: '/fna', label: 'QnA Enhancement' },
    { to: '/logs', label: 'Log File Report' },
]

export function Sidebar() {
    const routerState = useRouterState()
    const navigate = useNavigate()
    const currentPath = routerState.location.pathname
    const { logout } = useAuth()
    const [showLogoutModal, setShowLogoutModal] = useState(false)

    const handleLogout = () => {
  setShowLogoutModal(true)
  }

  const confirmLogout = () => {
  logout()
  navigate({ to: '/login' })
  }

  return (
  <>
  <aside className="w-64 border-r border-gray-200 bg-white flex flex-col h-full">
        <div className="p-6 flex justify-center">
        <img src={logoImg} alt="BUV Logo" className="w-40 object-contain" />
        </div>

        <nav className="px-3 flex-1">
        {navItems.map((item) => {
          const isActive = currentPath === item.to || (item.to === '/' && currentPath.startsWith('/chatbot'))

          return (
          <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-3 px-3 py-3 mb-1 rounded-md text-sm font-medium transition-colors ${
              isActive
                    ? 'bg-red-50 text-[#D91F27]'
                    : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
              <span>{item.label}</span>
          </Link>
          )
        })}
        </nav>

        <div className="p-4 border-t border-gray-200">
        <Button
          variant="ghost"
          className="w-full justify-start gap-2 text-gray-700 hover:text-[#D91F27] hover:bg-red-50"
          onClick={handleLogout}
        >
          <LogOut size={16} />
          Logout
        </Button>
        </div>
  </aside>
  <ConfirmationModal
  isOpen={showLogoutModal}
  onClose={() => setShowLogoutModal(false)}
  onConfirm={confirmLogout}
  title="Log out?"
  description="You can sign back in anytime."
  confirmText="Logout"
  />
  </>
  )
}
